module.exports = __webpack_public_path__ + "static/chauffage1-84f2d1fb18da04166e7ce6c530fa4a27.jpg";